var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSoundOff = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 100.13",
    style: {
      enableBackground: "new 0 0 122.88 100.13"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#fff;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.66,37.03c-1.4-1.4-1.4-3.66,0-5.05c1.4-1.4,3.66-1.4,5.05,0l13.03,13.03l13.03-13.03 c1.4-1.4,3.66-1.4,5.05,0c1.4,1.4,1.4,3.66,0,5.05L108.8,50.06l13.03,13.03c1.4,1.4,1.4,3.66,0,5.05c-1.4,1.4-3.66,1.4-5.05,0 l-13.03-13.03L90.72,68.14c-1.4,1.4-3.66,1.4-5.05,0c-1.4-1.4-1.4-3.66,0-5.05L98.7,50.06L85.66,37.03L85.66,37.03z M11.39,23.67 h26.4L60.26,1.05c1.39-1.4,3.64-1.4,5.04-0.01c0.7,0.7,1.05,1.61,1.05,2.53h0.01v92.99c0,1.97-1.6,3.57-3.57,3.57 c-1,0-1.91-0.41-2.56-1.08L37.98,80.29H11.39c-3.13,0-5.98-1.28-8.04-3.34C1.28,74.89,0,72.04,0,68.91V35.06 c0-3.13,1.28-5.98,3.34-8.04C5.4,24.95,8.25,23.67,11.39,23.67L11.39,23.67z M39.26,30.82H11.39c-1.16,0-2.22,0.48-2.99,1.25 c-0.77,0.77-1.25,1.83-1.25,2.99v33.85c0,1.16,0.48,2.22,1.25,2.99c0.77,0.77,1.83,1.25,2.99,1.25h27.87v0.02 c0.81,0,1.62,0.27,2.29,0.83l17.67,14.9V12.21L41.97,29.57C41.32,30.33,40.34,30.82,39.26,30.82L39.26,30.82z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSoundOff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sound_off.4fd56b89.svg";
export { ForwardRef as ReactComponent };